/** A stalled download is not necessarily stalled playback (the buffer may still play). */
export function bindMediaLoading(video: HTMLVideoElement, setLoading: (loading: boolean) => void) {
  let timer: ReturnType<typeof setTimeout> | null = null;
  let lastTime = video.currentTime;
  const hide = () => {
    if (timer !== null) clearTimeout(timer);
    timer = null;
    setLoading(false);
  };
  const queue = () => {
    if (timer !== null || video.paused || video.ended || video.error || video.dataset.releasing === 'true' || video.readyState >= 3) return;
    const queuedTime = video.currentTime;
    timer = setTimeout(() => {
      timer = null;
      if (video.paused || video.ended || video.error || video.dataset.releasing === 'true' || video.readyState >= 3 || video.currentTime !== queuedTime) return;
      setLoading(true);
    }, 450);
  };
  const progress = () => {
    if (video.currentTime !== lastTime && !video.seeking) hide();
    lastTime = video.currentTime;
  };
  const listeners: Array<[string, () => void]> = [
    ['waiting', queue], ['stalled', queue], ['playing', hide], ['canplay', hide],
    ['pause', hide], ['ended', hide], ['emptied', hide], ['error', hide], ['timeupdate', progress],
  ];
  listeners.forEach(([event, handler]) => video.addEventListener(event, handler));
  return { hide, dispose: () => {
    listeners.forEach(([event, handler]) => video.removeEventListener(event, handler));
    hide();
  } };
}
